/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Trigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Trigger({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Trigger"
  
}) {
let orderStatusValueData = fromData.useDataFormat({ viewPath,
context: 'order',
path: 'status',
format: fromFormat.toSentenceCase,
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 style="filled"
 type="grey"
 size="tiny"
>
{childProps => (
<React.Fragment>
<TysiaIconInfoFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 width={16}
 height={16}
 marginRight={2}
/>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="order.status"
 format="/Data/format.js toSentenceCase"
 text={orderStatusValueData}
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}